import { MHeaderProps } from "../../MHeader";
import { SubLayoutContext } from "./context";
import { useContext, useEffect, useRef } from "react";
import { useUnmount } from "react-use";

export function useHeaderProps(props: Partial<MHeaderProps>) {
    const { headerProps, setHeaderProps } = useContext(SubLayoutContext);
    const oldPropsRef = useRef(headerProps);

    // 注意, 传进来的extra参数必须使用useMemo包裹, 否则会造成无限刷新!!!
    // goback参数不刷新, 请自行调用下边的强刷函数
    useEffect(() => {
        setHeaderProps(props);
    }, [props.title, props.extra]);

    useUnmount(() => {
        setHeaderProps(oldPropsRef.current);
    });

    // 返回一个强制刷新函数
    return () => {
        setHeaderProps(props);
    };
}
